import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/Navbar";
import { CartDrawer } from "@/components/CartDrawer";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ArtworkDetailPage from "@/pages/ArtworkDetailPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import ContactPage from "@/pages/ContactPage";
import EverybodyLooksPage from "@/pages/EverybodyLooksPage";
import ComingSoonGate from "@/pages/ComingSoonGate";
import SpecialPage from "@/pages/SpecialPage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function AppShell() {
  useLenis();
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const [unlocked, setUnlocked] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlKey = params.get("key");
    const stored = urlKey || localStorage.getItem("mads_gate");
    if (!stored) {
      setChecking(false);
      return;
    }
    fetch(`${API}/site/unlock`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ key: stored }),
    })
      .then((r) => {
        if (r.ok) {
          localStorage.setItem("mads_gate", stored);
          setUnlocked(true);
          if (urlKey) window.history.replaceState({}, "", window.location.pathname);
        } else {
          localStorage.removeItem("mads_gate");
        }
      })
      .catch(() => {})
      .finally(() => setChecking(false));
  }, []);

  if (checking) {
    return <div className="min-h-screen bg-[#F5E8D0]" data-testid="gate-loading" />;
  }

  if (!unlocked) {
    return <ComingSoonGate onUnlock={() => setUnlocked(true)} />;
  }

  return (
    <div className="min-h-screen bg-[#F5E8D0] text-[#2A2118]">
      <div className="grain-overlay" />
      {!isHome && <Navbar />}
      <CartDrawer />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/artwork/:id" element={<ArtworkDetailPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/collections/everybody-looks" element={<EverybodyLooksPage />} />
          <Route path="/special" element={<SpecialPage />} />
        </Routes>
      </main>
      {!isHome && <Footer />}
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FBF3E2",
            border: "1px solid rgba(42,33,24,0.1)",
            color: "#2A2118",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
